<div *ngIf="fetching" class="fetching-files">
    <mat-spinner></mat-spinner>
</div>
<div id="cache-container" class="cache-container">
    <div id="header-bar" class="header-bar">
        <div class="header-text-div">
            <span id="header-text" class="header-text">{{ cachedBankCodesTitle }}</span>
        </div>
        <app-button data-testid="export-button" (clicked)="export()" [showIcon]="true" icon="download" label="Export" />
    </div>
    <div class="main">
        <div id="data-container" class="data-container">
            <div id="search-bar" class="search-bar">
                <app-search
                    placeholder="Filter by name, ID, etc."
                    data-testid="app-caches-search"
                    (newSearchEvent)="performSearch($event)"
                    [initialValue]="searchValue"
                ></app-search>
            </div>
            <div *ngIf="cachedBankCodesCount > 0" id="count-div" class="count-div">
                <span id="cache-count" class="chache-count">{{ cachedBankCodesCount }} Results</span>
            </div>
        </div>
        <div class="table-container">
            <app-cache-table
                class="cache-table"
                data-testid="app-cache-table"
                [cacheRecords]="cacheRecords"
                [searchText]="searchValue"
                [fetching]="fetching"
                (deleteEvent)="handleDelete($event)"
                [initialSort]="{ id: sortField, start: sortDir }"
                (sortEvent)="handleSortChange($event)"
            ></app-cache-table>
        </div>
    </div>
</div>
